import BaseService from "./baseService";

class ProjectService extends BaseService {
  constructor() {
    super("/project-list");
  }

  async getAllProjects() {
    return this.get("");
  }

  async getProjectById(id: string) {
    return this.get(`/${id}`);
  }

  async updateProjectName(id: string, name: string) {
    return this.patch(`/${id}`, { project_name: name });
  }

  async createProject(name: string) {
    return this.post("", { project_name: name });
  }
}

export default new ProjectService();
